<div class="p-2 bg-gray-50 min-h-screen">
  <!-- PAGE HEADER -->
  <div class="flex justify-between items-center mb-4">
    <div>
      <h3 class="text-lg font-semibold text-gray-800">{{ 'MONITORING.TITLE' | translate }}</h3>

      @if (clntNm) {
        <p class="text-sm text-gray-500 mt-1">{{ clntNm }}</p>
      }
    </div>

    <app-back-button></app-back-button>
  </div>

  <div class="bg-white rounded-2xl p-5">
    <!-- TABS -->
    <div class="flex gap-6 border-b border-gray-200 mb-5">
      <!-- <button
        (click)="setTab('outputs')"
        class="pb-2 text-sm font-medium"
        [ngClass]="
          activeTab === 'outputs'
            ? 'border-b-2 border-indigo-600 text-indigo-600'
            : 'text-gray-500 hover:text-indigo-600'
        "
      >
        Measurable Outputs
      </button> -->
      <button
        (click)="setTab('findings')"
        class="pb-2 text-sm font-medium"
        [ngClass]="
          activeTab === 'findings'
            ? 'border-b-2 border-indigo-600 text-indigo-600'
            : 'text-gray-500 hover:text-indigo-600'
        "
      >
        {{ 'MONITORING.TAB_AGREED_ACTION_PLAN' | translate }}
      </button>

      <button
        (click)="setTab('covenants')"
        class="pb-2 text-sm font-medium"
        [ngClass]="
          activeTab === 'covenants'
            ? 'border-b-2 border-indigo-600 text-indigo-600'
            : 'text-gray-500 hover:text-indigo-600'
        "
      >
        {{ 'MONITORING.TAB_COVENANT_COMPLIANCE' | translate }}
      </button>

      <button
        (click)="setTab('report')"
        class="pb-2 text-sm font-medium"
        [ngClass]="
          activeTab === 'report'
            ? 'border-b-2 border-indigo-600 text-indigo-600'
            : 'text-gray-500 hover:text-indigo-600'
        "
      >
        {{ 'MONITORING.TAB_MONITORING_REPORT' | translate }}
      </button>
    </div>

    <!-- TAB: MEASURABLE OUTPUTS -->
    <!-- @if (activeTab === 'outputs') {
      <div class="space-y-6">
        @if (outputsLoading) {
          <div class="text-sm text-gray-500">Loading monitoring data...</div>
        }

        @if (outputsError) {
          <div class="text-sm text-red-600">{{ outputsError }}</div>
        }

        @if (!outputsLoading) {
          <p class="text-sm text-gray-500">
            Use the edit action on a row to open it in Agreed Action Plan.
          </p>
          <div>
            <h4 class="text-sm font-semibold text-gray-700 mb-2">Previous Pending</h4>
            @if (pendingError) {
              <div class="text-sm text-red-600">{{ pendingError }}</div>
            } @else if (pendingRows.length === 0) {
              <div class="text-sm text-gray-400">Nothing pending for this client.</div>
            } @else {
              <app-table
                [columns]="itemColumns"
                [data]="pendingRows"
                [actions]="outputActions"
                [enablePagination]="true"
                [pageSize]="10"
                searchPlaceholder="Search pending items..."
              ></app-table>
            }
          </div>
          <div>
            <h4 class="text-sm font-semibold text-gray-700 mb-2">Previous Year</h4>
            @if (previousError) {
              <div class="text-sm text-red-600">{{ previousError }}</div>
            } @else if (previousRows.length === 0) {
              <div class="text-sm text-gray-400">No data for the previous year.</div>
            } @else {
              <app-table
                [columns]="itemColumns"
                [data]="previousRows"
                [actions]="outputActions"
                [enablePagination]="true"
                [pageSize]="10"
                searchPlaceholder="Search previous year..."
              ></app-table>
            }
          </div>
        }
      </div>
    } -->

    <!-- TAB: AGREED ACTION PLAN -->
    @if (activeTab === 'findings') {
      <div class="space-y-4">
        <div class="max-w-xs">
          <label class="text-xs font-medium text-gray-500" for="evntDt">
            {{ 'MONITORING.MONITORING_VISIT_DATE' | translate }} <span class="text-red-500">*</span>
          </label>

          <input
            id="evntDt"
            type="date"
            [(ngModel)]="evntDt"
            (ngModelChange)="onEventDateChange()"
            name="evntDt"
            class="mt-1 w-full h-11 px-3 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
          />
        </div>

        @for (finding of visibleFindings; track $index) {
          <div class="border border-gray-200 rounded-2xl p-4">
            <div class="flex justify-between items-center mb-3">
              <span class="text-sm font-medium text-gray-700">
                {{ finding.mntrngSeq ? ('MONITORING.EXISTING_ITEM' | translate: { id: finding.mntrngSeq }) : ('MONITORING.NEW_ACTION_PLAN' | translate: { n: $index + 1 }) }}
              </span>

              <button
                type="button"
                class="text-xs text-red-500 hover:underline"
                (click)="removeFinding(finding)"
              >
                {{ 'COMMON.REMOVE' | translate }}
              </button>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div class="lg:col-span-2">
                <label class="text-xs font-medium text-gray-500" [attr.for]="'dscrptn-' + $index">
                  {{ 'COMMON.DESCRIPTION' | translate }} <span class="text-red-500">*</span>
                </label>

                <textarea
                  [id]="'dscrptn-' + $index"
                  rows="2"
                  [(ngModel)]="finding.dscrptn"
                  [name]="'dscrptn-' + $index"
                  [placeholder]="'MONITORING.OBSERVATION_PLACEHOLDER' | translate"
                  class="mt-1 w-full px-3 py-2 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
                ></textarea>
              </div>

              <div>
                <label class="text-xs font-medium text-gray-500" [attr.for]="'rmrks-' + $index">
                  {{ 'COMMON.REMARKS' | translate }}
                </label>

                <input
                  [id]="'rmrks-' + $index"
                  type="text"
                  [(ngModel)]="finding.rmrks"
                  [name]="'rmrks-' + $index"
                  class="mt-1 w-full h-11 px-3 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
                />
              </div>

              <div>
                <label class="text-xs font-medium text-gray-500" [attr.for]="'sts-' + $index">
                  {{ 'COMMON.STATUS' | translate }}
                </label>

                <select
                  [id]="'sts-' + $index"
                  [(ngModel)]="finding.sts"
                  [name]="'sts-' + $index"
                  class="mt-1 w-full h-11 px-3 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
                >
                  @for (option of statusOptions; track option.value) {
                    <option [ngValue]="option.value">{{ option.label | translate }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        }

        <div class="flex flex-wrap gap-3">
          <button type="button" class="btn-secondary" (click)="addFinding()">{{ 'MONITORING.ADD_ACTION_PLAN' | translate }}</button>

          <button
            type="button"
            class="btn-primary"
            [disabled]="savingFindings"
            (click)="saveFindings()"
          >
            {{ (savingFindings ? 'COMMON.SAVING' : 'MONITORING.SAVE_ACTION_PLAN') | translate }}
          </button>
        </div>

        <!-- ALREADY ON RECORD -->
        <div class="pt-5 mt-2 border-t border-gray-200">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">
            {{ 'MONITORING.ACTION_PLAN_ALREADY_SAVED' | translate }} <span class="font-normal text-gray-400">({{ findingsYear }})</span>
          </h4>

          @if (savedItemsLoading) {
            <div class="text-sm text-gray-500">{{ 'MONITORING.LOADING_SAVED_ACTION_PLAN' | translate }}</div>
          } @else if (savedItemsError) {
            <div class="text-sm text-red-600">{{ savedItemsError | translate }}</div>
          } @else if (savedItems.length === 0) {
            <div class="text-sm text-gray-400">{{ 'MONITORING.NO_ACTION_PLAN_SAVED' | translate: { year: findingsYear } }}</div>
          } @else {
            <app-table
              [columns]="savedItemColumns"
              [data]="savedItems"
              [actions]="outputActions"
              [enablePagination]="true"
              [pageSize]="10"
              searchPlaceholder="MONITORING.SEARCH_SAVED_ACTION_PLAN"
            ></app-table>
          }
        </div>
      </div>
    }

    <!-- TAB: COVENANT COMPLIANCE -->
    @if (activeTab === 'covenants') {
      <div class="space-y-4">
        <p class="text-sm text-gray-500">
          {{ 'MONITORING.COVENANT_INTRO' | translate }}
        </p>

        @if (covenantsLoading && covenantRows.length === 0) {
          <div class="text-sm text-gray-500">{{ 'MONITORING.LOADING_COVENANTS' | translate }}</div>
        } @else if (covenantsError) {
          <div class="text-sm text-red-600">{{ covenantsError | translate }}</div>
        } @else if (covenantRows.length === 0) {
          <div class="text-sm text-gray-400">{{ 'MONITORING.NO_COVENANT_RESPONSES' | translate }}</div>
        } @else {
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead>
                <tr class="text-start text-gray-600 border-b border-gray-200">
                  <th class="py-2 pe-4 w-14">{{ 'MONITORING.S_NO_SHORT' | translate }}</th>
                  <th class="py-2 pe-4">{{ 'MONITORING.COVENANT' | translate }}</th>
                  <th class="py-2 pe-4 w-72">{{ 'COMMON.REMARKS' | translate }}</th>
                  <th class="py-2 pe-4 w-44">{{ 'MONITORING.COVENANT_STATUS' | translate }}</th>
                  <th class="py-2 w-32">{{ 'MONITORING.QUARTER' | translate }}</th>
                </tr>
              </thead>

              <tbody>
                @for (row of covenantRows; track row.crdtCnvntRspSeq; let i = $index) {
                  <tr
                    class="border-b border-gray-100 align-top"
                    [class.bg-amber-50]="isCovenantRowChanged(row)"
                  >
                    <td class="py-3 pe-4 text-gray-500">{{ i + 1 }}</td>

                    <td class="py-3 pe-4 text-gray-800 whitespace-pre-line">{{ row.question }}</td>

                    <td class="py-3 pe-4">
                      <input
                        type="text"
                        [(ngModel)]="row.rmrks"
                        [name]="'rmrks-' + row.crdtCnvntRspSeq"
                        class="w-full h-10 px-3 border border-gray-200 rounded-lg bg-white text-sm outline-none focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
                        [placeholder]="'COMMON.REMARKS' | translate"
                      />
                    </td>

                    <td class="py-3 pe-4">
                      <select
                        [(ngModel)]="row.ansVal"
                        [name]="'ansVal-' + row.crdtCnvntRspSeq"
                        class="w-full h-10 px-3 border border-gray-200 rounded-lg bg-white text-sm outline-none focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
                      >
                        <option [ngValue]="null">{{ 'MONITORING.NOT_ANSWERED' | translate }}</option>

                        @for (option of covenantOptions; track option.value) {
                          <option [ngValue]="option.value">{{ option.label | translate }}</option>
                        }
                      </select>

                      @if (row.ansVal !== row.originalAnsVal) {
                        <span class="mt-1 block text-xs text-amber-700">
                          {{ 'MONITORING.WAS_VALUE' | translate: { value: (answerLabel(row.originalAnsVal) | translate) } }}
                        </span>
                      }
                    </td>

                    <!-- Quarter is view only: the row's own quarter, else the response's current quarter. -->
                    <td class="py-3">
                      <div class="min-h-10 py-2.5 text-center text-gray-800 whitespace-nowrap">
                        {{ quarterMonth(row.qrtr || covenantQuarter) || '-' }}
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div class="flex flex-wrap items-center gap-3 pt-1">
            @if (covenantsLoading) {
              <span class="text-xs text-gray-400">{{ 'MONITORING.REFRESHING' | translate }}</span>
            }

            <button
              type="button"
              class="btn-primary"
              [disabled]="savingCovenants || covenantsLoading || changedCovenantRows.length === 0"
              (click)="saveCovenants()"
            >
              {{ (savingCovenants ? 'COMMON.SAVING' : 'MONITORING.SAVE_RESPONSES') | translate }}
            </button>

            @if (changedCovenantRows.length) {
              <button type="button" class="btn-outline" (click)="resetCovenants()">{{ 'COMMON.RESET' | translate }}</button>

              <span class="text-xs text-amber-700">
                {{ (changedCovenantRows.length === 1 ? 'MONITORING.UNSAVED_CHANGE' : 'MONITORING.UNSAVED_CHANGES') | translate: { count: changedCovenantRows.length } }}
              </span>
            }
          </div>
        }
      </div>
    }

    <!--
      TAB: MONITORING REPORT
      Kept mounted but hidden once opened so a part-filled upload form is not
      thrown away by a tab switch.
    -->
    @if (reportVisited) {
      <div [class.hidden]="activeTab !== 'report'">
        <div class="flex justify-end mb-3">
          <button type="button" class="btn-primary" (click)="openUploadReportPopup()">
            {{ 'MONITORING.UPLOAD_MONITORING_REPORT' | translate }}
          </button>
        </div>

        <!--
          Reports are saved with entySeq = clntSeq (see saveUploadReport), so
          they're listed the same way: single-entity mode, which calls the
          existing GET /leads/get-lead-docs-list/{leadSeq}/{entyTyp} through
          LeadService.getLeadDocs — same call every other screen uses.
        -->
        <app-document
          [moduleSeq]="reportDocCategory"
          [entitySeq]="clntSeq"
          [viewOnly]="true"
          [showVisitDateColumn]="true"
        ></app-document>
      </div>
    }
  </div>
</div>

<!--
  UPLOAD MONITORING REPORT MODAL
  Same visual structure/classes as the shared Document component's own
  upload modal (leads/document/document.html), with "Document Name" swapped
  for a required "Visit Date" field.
-->
@if (showUploadReportPopup) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div class="bg-white rounded-2xl w-[90%] max-w-2xl p-8 relative">
      <!-- CLOSE -->
      <button
        type="button"
        (click)="closeUploadReportPopup()"
        class="absolute top-6 end-6 w-10 h-10 rounded-full border flex items-center justify-center hover:bg-gray-100"
      >
        ✕
      </button>

      <!-- TITLE -->
      <h2 class="text-xl font-semibold mb-6">{{ 'MONITORING.UPLOAD_MONITORING_REPORT' | translate }}</h2>

      <!-- ================= FIELDS ================= -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="text-xs font-medium text-gray-500" for="uploadReportDocTyp">
            {{ 'MONITORING.DOCUMENT_TYPE' | translate }} <span class="text-red-500">*</span>
          </label>

          <select
            id="uploadReportDocTyp"
            [(ngModel)]="uploadReportDocTyp"
            name="uploadReportDocTyp"
            class="mt-1 w-full h-11 px-3 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
          >
            <option [ngValue]="null">{{ 'MONITORING.SELECT_DOCUMENT_TYPE' | translate }}</option>

            @for (option of uploadReportDocTypeOptions; track option.value) {
              <option [ngValue]="option.value">{{ option.label | translate }}</option>
            }
          </select>
        </div>

        <div>
          <label class="text-xs font-medium text-gray-500" for="uploadReportVisitDate">
            {{ 'MONITORING.VISIT_DATE' | translate }} <span class="text-red-500">*</span>
          </label>

          <input
            id="uploadReportVisitDate"
            type="date"
            [(ngModel)]="uploadReportVisitDate"
            name="uploadReportVisitDate"
            class="mt-1 w-full h-11 px-3 border border-gray-200 rounded-xl bg-white text-sm text-gray-800 outline-none transition-all focus:border-[#1E2A78] focus:ring-2 focus:ring-[#1E2A78]/10"
          />
        </div>
      </div>

      <!-- ================= FILE UPLOAD ================= -->
      <div
        class="border-2 border-dashed border-gray-300 rounded-2xl h-44 flex flex-col items-center justify-center cursor-pointer hover:border-indigo-500 transition mb-6 mt-4"
        (click)="uploadReportFileInput.click()"
      >
        <img src="images/upload.png" class="w-12 mb-2 opacity-70" />

        <p class="text-gray-500 text-sm">{{ 'MONITORING.CLICK_TO_UPLOAD' | translate }}</p>
      </div>

      <!-- FILE NAME -->
      @if (uploadReportFile) {
        <p class="text-xs text-green-600 mb-4 text-center">{{ uploadReportFile.name }}</p>
      }

      <input
        #uploadReportFileInput
        type="file"
        accept=".pdf,.doc,.docx"
        class="hidden"
        (change)="onUploadReportFileSelected($event)"
      />

      <div class="flex gap-4 mt-4">
        <button
          [disabled]="savingUploadReport"
          (click)="saveUploadReport()"
          class="px-6 py-2 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ (savingUploadReport ? 'COMMON.SAVING' : 'COMMON.SAVE') | translate }}
        </button>

        <button
          type="button"
          (click)="closeUploadReportPopup()"
          class="px-6 py-2 rounded-lg bg-red-500 text-white font-medium hover:bg-red-600"
        >
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
}
